module.exports = __webpack_public_path__ + "static/img/type1.0834db4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type1.png
// module id = LbVy
// module chunks = 1